module.exports = {"150782001":"胜利街道","150782002":"红旗街道","150782003":"新工街道","150782004":"永兴街道","150782005":"建设街道","150782006":"暖泉街道","150782100":"免渡河镇","150782101":"博克图镇","150782102":"绰河源镇","150782103":"乌尔其汉镇","150782104":"库都尔镇","150782105":"图里河镇","150782106":"乌奴耳镇","150782107":"塔尔气镇","150782108":"伊图里河镇","150782109":"牧原镇","150782400":"莫拐农场","150782401":"牙克石农场","150782402":"免渡河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150782.json
// module id = 455
// module chunks = 0